import PropTypes from 'prop-types';

const props = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  variant: PropTypes.oneOf([
    'white-primary',
    'green-primary',
    'black-primary',
    'orange-primary',
    'danger',
    'aqua',
  ]),
};

const sizeStyle = {
  xs: 'h-12',
  sm: 'h-h31',
  md: 'h-h42',
  lg: 'h-h48',
};

const variantStyle = {
  'white-primary': 'tw-bg-white tw-text-[#001316] hover:tw-bg-[#f0f0f0] hover:tw-text-[#001316]',
  'green-primary':
    'tw-bg-[#00FFCC] tw-text-[#001316] hover:tw-bg-[#00cc99] hover:tw-text-[#001316]',
  'black-primary': 'tw-bg-[#003E48] tw-text-white hover:tw-bg-[#002c34] hover:tw-text-white',
  'orange-primary': 'tw-bg-[#FFD747] tw-text-[#001316] hover:tw-bg-[#FFE858]', //hover:tw-text-white
  // TODO: Add hover effects
  danger: 'tw-bg-[#E15A5A] tw-text-white',
  aqua: 'tw-bg-[#75F7FF] tw-text-[#003E48]',
};

/*
TODO: Refactor later based on different usecases

p-4

primary, secondary
color

text = "One Time"
className = " w-w156 py-4  border-2 leading-lh16.8"

text = "SIP"
className = "h-12 w-w156 py-4 leading-lh16.8"

text = "Stop"
className = " font-neuepower h-12 w-w156 py-4  border-2 leading-lh16.8"

text = "Reedem"
className = " font-neuepower h-12 w-w156 py-4  leading-lh16.8 rounded"

text = "Start Now"
className = ' font-sans text-base w-w104  p-2.5 leading-lh29 font-medium'

text = "Start Investing"
className = ' font-sans text-sm w-w137 p-2.5 leading-lh16.8 '

text = "Order Details"
className = ' font-mulish text-sm w-w156 h-h48 py-4 leading-lh17.7 bg-primaryBlue text-black'
*/

export default function Button({
  children,
  className = '',
  disabled,
  onClick,
  size = 'md',
  variant = 'white-primary',
  rounded = false,
  width = 'default',
}) {
  const buttonClasses = `tw-p-4 tw-gap-2 tw-text-sm tw-font-bold ${rounded ? 'tw-rounded-full' : 'tw-rounded-md'} tw-cursor-pointer tw-flex tw-items-center tw-justify-center ${width && 'tw-w-[230px]'}
  ${sizeStyle[size] || sizeStyle.md} 
  ${variantStyle[variant] || variantStyle['blue-primary']} 
  ${className}`;

  return (
    <button
      className={buttonClasses + (disabled ? ' cursor-not-allowed' : '')}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

Button.propTypes = props;
